export { View as Tab2019 } from './view'
